<template>
  <div
    ref="anchor"
    :class="['lego-modal', 'lego-scroll', { 'fix-size': fixSize }]"
    :style="anchorStyle"
    v-show="isOpen"
    @mouseup="mUp"
    @mousemove="mMove"
    @click="onClick"
    @keydown.tab="shiftTabEvent"
    @keydown.tab.exact="tabEvent"
    @keydown.esc="keyClose"
    @keydown.backspace="keyBackspace"
    v-bind="$attrs"
  >
    <button class="lego-modal-focus__start" ref="focusStart" />
    <div class="lego-modal__blocker" ref="blocker" />
    <div class="lego-modal__container--wrapper lego-scroll__content">
      <div class="lego-modal__container" ref="modal" :style="modalStyle" :class="modalClass">
        <div class="lego-modal__head" :class="headClass" @mousedown="mDown">
          <span class="lego-modal__title"
            >{{ title }} <em class="subtitle">{{ subTitle }}</em></span
          >
        </div>
        <lego-icon
          class="lego-modal__close"
          icon-type="df"
          icon="delete"
          :size:="16"
          @click.stop="close"
        />
        <div v-if="tbody" class="lego-modal__tbody">
          <slot name="tbody" />
        </div>
        <div :class="[{ 'lego-modal__body': true }, `lego-modal__body__${type}`]">
          <c-scroll
            v-if="isOpen && ['normal', 'unset'].includes(type)"
            ref="scrollContainer"
            :classStyle="classStyle"
            :style="{ maxHeight: this.customHeight }"
          >
            <slot ref="slot">{{ content }}</slot>
          </c-scroll>
          <div v-else-if="type === 'noscr'">
            <slot ref="slot">{{ content }}</slot>
          </div>
          <div v-else v-html="content" :class="content.indexOf('<') == -1 && 'text-content'" />
        </div>
        <div class="lego-modal__foot">
          <slot class="lego-modal__action" name="action" :close="close" />
        </div>
        <div class="lego-modal__ghost" v-show="mMoving" :style="ghostStyle"></div>
      </div>
    </div>
    <button class="lego-modal-focus__end" ref="focusEnd" />
  </div>
</template>

<script>
let ZIDX = 3000;
const ZIDX_MAP = new Map();

function modalPush(key) {
  let zidx = ++ZIDX;
  ZIDX_MAP.set(key, zidx);
  return zidx;
}

function modalPop(key) {
  // 1. check map exist
  if (!ZIDX_MAP.has(key)) return -1; // 아무의미 없음. 안쓰임. code smell 회피
  // 2. get his/her zidx
  let zidx = ZIDX_MAP.get(key);
  // 3. delete from map
  ZIDX_MAP.delete(key);
  // 4. set ZIDX
  //    조심! 모달 열리는 순서 꼬이는경우
  //    조심! blocker 안하는 경우, 아무렇게나 모달을 열었을때
  //        -> 그때는 focus 기반으로 active 배열을 얹어야 할지도.. 문제는 속도지 뭐
  ZIDX = zidx - 1;
  return 0;
}

export default {
  name: 'lego-modal',
  props: {
    xsmall: {
      CScrolltype: Boolean,
      default: false
    },
    size: {
      type: [String, Number],
      default: null
    },
    content: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['alert', 'confirm', 'normal', 'noscr', 'unset'].indexOf(value) !== -1;
      }
    },
    tbody: {
      type: Boolean,
      default: false
    },
    fixSize: {
      type: Boolean,
      default: true
    },
    customHeight: {
      type: String,
      default: 'calc(80vh - 189px)'
    },
    subTitle: { type: String, default: '' },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      /* [DATA] for Open/Close modal */
      isOpen: this.visible,
      /* [DATA] for Positioning*/
      posx: 0,
      posy: 0,
      zidx: 0,
      /* [DATA] for Modal moving */
      mMoving: false,
      mxStart: 0,
      myStart: 0,
      mxEnd: 0,
      myEnd: 0,
      /* [DATA] Temp data */
      tempKey: '',
      modalH: 0,
      modalBodyH: 0,
      modalScrollH: 0
    };
  },
  methods: {
    tabEvent(e) {
      if (e.target.classList.value === 'lego-modal-focus__end') {
        this.$refs.blocker.focus();
      }
    },
    shiftTabEvent(e) {
      if (e.target.classList.value === 'lego-modal-focus__start') {
        this.$refs.focusEnd.focus();
      }
    },
    dimOn() {
      const isBodyScroll = document.body.scrollHeight > document.body.clientHeight;
      if (isBodyScroll) {
        document.body.classList.add('modal-on', 'modal-on-scroll');
      } else {
        document.body.classList.add('modal-on');
      }
    },
    dimOff() {
      const modal = document.body.getElementsByClassName('lego-modal');
      if (!modal || !modal.length) {
        document.body.classList.remove('modal-on', 'modal-on-scroll');
      }
    },
    open(e) {
      this.dimOn();
      document.activeElement.blur();
      // 1. set focus
      this.isOpen = true;
      this.$nextTick(() => {
        let anchor = this.$refs.blocker;
        anchor.setAttribute('tabindex', -1);
        anchor.focus();
      });
      // 2. set zidx
      this.zidx = modalPush(this.tempKey);

      //this.posx = window.innerWidth  / 2;
      //this.posy = window.innerHeight / 2;

      // $ver: v0.1.0
      // $return: event
      // 팝업이 열릴 때, 이벤트를 발생시킵니다.
      this.$emit('opened', e);

      this.$slots.default().forEach((defaultSlot) => {
        if (!defaultSlot.componentInstance) {
          return;
        }
        let fn = defaultSlot.componentInstance.onLoadModal;
        if (fn && typeof fn === 'function') {
          fn();
        }
      });
      this.$slots.action &&
        this.$slots.action().forEach((actionSlot) => {
          if (!actionSlot.componentInstance) {
            return;
          }
          let fn = actionSlot.componentInstance.onLoadModal;
          if (fn && typeof fn === 'function') {
            fn();
          }
        });

      this.$nextTick(() => {
        this.moveModal(0, 0);
      });
    },
    close(e) {
      //console.log('legoModalExtend... close')
      this.dimOff();
      if (this.$attrs['onBeforeClose']) {
        // $ver: v0.1.2
        // $arg: function close()
        // beforeClose라는 event에 callback method가 설정되어있다면 modal을 닫기 전에
        // 해당 callback을 실행합니다. 첫번 째 인자로 modal을 닫는 function이 전달됩니다.
        // #If the callback method is set in the beforeClose event, the callback is executed before closing the modal.
        // #The first argument is passed a function that closes the modal.
        this.$attrs['onBeforeClose'](() => {
          this.isOpen = false;
          this.$emit('closed', e);
          this.zidx = modalPop(this.tempKey);
        });
      } else {
        this.isOpen = false;

        // $ver: v0.1.0
        // $arg: event
        // 팝업이 닫힐 때, 이벤트를 발생시킵니다.
        // #Raises an event when the popup closes.
        this.$emit('closed', e);
        this.zidx = modalPop(this.tempKey);
      }
    }
  },
  computed: {
    classStyle() {
      let className = 'modal-scroll';
      if (this.type === 'alert' || this.type === 'confirm') className = 'modal-scroll modal-plugin';
      return className;
    },
    modalStyle() {
      let arrStyle = {};
      // 1. position
      if ((this.posy || this.posx) && !this.fixSize) {
        //arrStyle["left"] = parseInt(this.posx)+"px";
        //arrStyle["top"]  = parseInt(this.posy)+"px";
        arrStyle['transform'] = `translate(${parseInt(this.posx)}px,${parseInt(this.posy)}px)`;
      }
      // 2. if moving :: opacity
      if (this.mMoving) {
        arrStyle['opacity'] = 0.4;
      }

      if (this.modalWidth) {
        arrStyle['width'] = this.modalWidth + 'px';
      }
      arrStyle['overflow'] = 'hidden';
      return { ...arrStyle, ...this.customStyle };
    },
    modalClass() {
      let clazz = [];
      if (this.xsmall || this.size === 'xsmall') {
        clazz.push('lego-modal__container--xsmall');
      }
      if (this.small || this.size === 'small') {
        clazz.push('lego-modal__container--small');
      }
      if (this.medium || this.size === 'medium') {
        clazz.push('lego-modal__container--medium');
      }
      if (this.large || this.size === 'large') {
        clazz.push('lego-modal__container--large');
      }
      if (this.xlarge || this.size === 'xlarge') {
        clazz.push('lego-modal__container--xlarge');
      }
      if (this.xxlarge || this.size === 'xxlarge') {
        clazz.push('lego-modal__container--xxlarge');
      }
      return clazz;
    },
    modalWidth() {
      if (this.size) {
        switch (this.size) {
          case 'xsmall':
            return 460;
          case 'small':
            return 460;
          case 'medium':
            return 704;
          case 'large':
            return 904;
          case 'xlarge':
            return 1104;
          case 'slarge':
            return 1280;
          case 'xxlarge':
            return 1521;
        }
      }
      return this.size;
    }
  },
  unmounted() {
    this.dimOff();
  }
};
</script>
<style scoped lang="scss">
.lego-modal {
  &.fix-size {
    .lego-modal__container--wrapper {
      justify-content: inherit;
    }

    .lego-modal__container {
      flex: 0 0 auto;
      margin: 0 auto;
    }
  }

  &__head {
    position: static;
    padding: 24px 0 8px;
    margin: 0 32px;
    height: auto;
    border-bottom: 1px solid $color--ui07;
  }

  :deep .lego-modal__close.lego-icon {
    top: 34px;
  }

  &__title {
    @include font($size: $lego-modal__title__font-size, $weight: 700);
  }

  &__close {
    &.lego-icon {
      top: 33px;
      font-size: 24px;
    }
  }

  &__container {
    padding: 0;
    max-height: 80%;
  }

  &__body {
    margin: 0;
    padding: 20px 32px 22px 52px;

    &.lego-modal__body__confirm,
    &.lego-modal__body__alert,
    &.lego-modal__body__noscr {
      padding: 20px 52px 20px 52px;
    }

    &.lego-modal__body__unset {
      padding: 0px;
    }

    min-height: 104px;
    // max-height: calc(80vh - 188px);

    .modal-scroll {
      min-height: 64px;

      :deep .simplebar-content {
        // width: 100%;
        width: calc(100% - 20px);
      }
    }

    .modal-scroll {
      :deep .lego-dropdown {
        .simplebar-content {
          width: 100%;
        }
      }
    }

    .modal-scroll {
      :deep .dropdown-submenu {
        .simplebar-content {
          width: 100%;
        }
      }
    }

    ~ .lego-modal__foot {
      margin-top: 0;
      background-color: transparent;
    }

    .text-content {
      word-break: keep-all;
    }
  }

  &__foot {
    position: relative;
    height: auto;
    padding: 20px 0 24px;
    margin: 0 32px;
    border-top: 1px solid $color--ui07;
  }

  &__container--xsmall {
    width: $lego-modal__width--xsmall;
  }
}

.lego-modal-focus__end,
.lego-modal-focus__start {
  opacity: 0;
}

.subtitle {
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  color: #a5a5a5;
  vertical-align: text-top;
  line-height: inherit;
  padding: 0 0 0 4px;
  margin: -3px 0 0 0;
  display: inline-block;
}
</style>
